/**
 * @generated SignedSource<<75eb7891a81409c31d3a5d92c5107edb>>
 * @relayHash d4d8baffc12cfe4e0148b636e010d7ef
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d4d8baffc12cfe4e0148b636e010d7ef

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BloodChemistry = "ALBUMIN" | "ALK_PHOSPHOTASE" | "AMYLASE" | "BILIRUBIN" | "BLOOD_SUGAR" | "CHLORIDE" | "CHOLSTEROL" | "CHOLSTEROL_HDL" | "CK" | "CREATININE" | "CRP" | "GAMMA_GT" | "GOT_ASAT" | "GPT_ALAT" | "HDL" | "LDH" | "NT_PRO_BNP" | "PHOSPHATE" | "POTASSIUM" | "SODIUM" | "TRIGLYCERIDE" | "TROPONIN_T" | "UREA" | "URIC_ACID";
export type Coagulation = "D_DIMER" | "INR" | "QUICK";
export type Hematology = "HAEMOGRAM_II" | "HAEMOGRAM_V" | "HBA1_C";
export type Language = "ENGLISH" | "FRENCH" | "GERMAN" | "ITALIAN";
export type RapidTest = "COVID19" | "LACTOSE_INTOTERANCE" | "STREP_A";
export type UrineDiagnostic = "BETA_HCG" | "MICROALBUMIN" | "STIX_SEDIMENT" | "URICULT";
export type Ch_createMeasLaboratoryPrescriptionInput = {
  bloodChemistries: ReadonlyArray<BloodChemistry>;
  coagulations: ReadonlyArray<Coagulation>;
  hematologies: ReadonlyArray<Hematology>;
  language: Language;
  patientId: string;
  progressNoteId: string;
  rapidTests: ReadonlyArray<RapidTest>;
  urineDiagnostics: ReadonlyArray<UrineDiagnostic>;
};
export type useChCreateMeasLaboratoryPrescriptionMutation$variables = {
  input: Ch_createMeasLaboratoryPrescriptionInput;
};
export type useChCreateMeasLaboratoryPrescriptionMutation$data = {
  readonly ch_createMeasLaboratoryPrescription: {
    readonly ch_MeasLaboratoryPrescription: {
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"chMeasLaboratoryPrescriptionFragment">;
    } | null;
    readonly errors: ReadonlyArray<{
      readonly message?: string;
    }> | null;
  };
};
export type useChCreateMeasLaboratoryPrescriptionMutation = {
  response: useChCreateMeasLaboratoryPrescriptionMutation$data;
  variables: useChCreateMeasLaboratoryPrescriptionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "type": "Error",
  "abstractKey": "__isError"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useChCreateMeasLaboratoryPrescriptionMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Ch_createMeasLaboratoryPrescriptionPayload",
        "kind": "LinkedField",
        "name": "ch_createMeasLaboratoryPrescription",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ch_MeasLaboratoryPrescription",
            "kind": "LinkedField",
            "name": "ch_MeasLaboratoryPrescription",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "chMeasLaboratoryPrescriptionFragment"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useChCreateMeasLaboratoryPrescriptionMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Ch_createMeasLaboratoryPrescriptionPayload",
        "kind": "LinkedField",
        "name": "ch_createMeasLaboratoryPrescription",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ch_MeasLaboratoryPrescription",
            "kind": "LinkedField",
            "name": "ch_MeasLaboratoryPrescription",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdBy",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "fileId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "language",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "patientId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "progressNoteId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "signedAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "signedBy",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "updatedAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "updatedBy",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sentAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sentBy",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "concludedAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "concludedBy",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "DocumentFileMetadata",
                "kind": "LinkedField",
                "name": "fileMetadata",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "documentType",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "extension",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lengthInKilobytes",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "bloodChemistries",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "coagulations",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hematologies",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "urineDiagnostics",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "rapidTests",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v3/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "d4d8baffc12cfe4e0148b636e010d7ef",
    "metadata": {},
    "name": "useChCreateMeasLaboratoryPrescriptionMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "3d1dfb28734efa98cf026ad8e6997138";

export default node;
